import router from '@/router';

const baseUrl = process.env.VUE_APP_API_URL || 'http://localhost:2200';

const appmixer = new window.Appmixer({
    baseUrl,
    tokenEncryptionKey: process.env.VUE_APP_ENCRYPTION_SECRET || 'secret',
    accessToken: sessionStorage.getItem('accessToken') || null,
    refreshToken: sessionStorage.getItem('refreshToken') || null
});

appmixer.api.on('tokenRefreshFailed', () => {
    // delete() routes through set(), which silently ignores null for tokens —
    // the unset* methods are the only way to actually clear them. Leaving the
    // dead refresh token in API state causes an endless POST /user/sso/refresh
    // loop: every API call 401s, triggers a refresh with the same dead token,
    // fails, and repeats.
    appmixer.api.unsetAccessToken();
    appmixer.api.unsetRefreshToken();
    sessionStorage.removeItem('accessToken');
    sessionStorage.removeItem('refreshToken');
    router.replace({ name: 'Login', query: { to: window.location.href } });
});

appmixer.api.on('accessTokenRefreshed', (tokens) => {
    if (tokens.accessToken && tokens.refreshToken) {
        sessionStorage.setItem('refreshToken', tokens.refreshToken);
        sessionStorage.setItem('accessToken', tokens.accessToken);
    }
});

export default appmixer;
